import { useCallback, useState } from 'react';
import {
  parseRsLocalDateYmd,
  shiftRsCalendarMonth,
} from '../utils/reservationBoardCalendar.util';

/** 共有予約表カレンダーの表示年月ナビ */
export function useRsBoardCalendarMonth() {
  const [today] = useState(() => new Date());
  const [year, setYear] = useState(() => today.getFullYear());
  const [month, setMonth] = useState(() => today.getMonth() + 1);

  const shiftMonth = useCallback(
    (delta: number) => {
      const next = shiftRsCalendarMonth(year, month, delta);
      setYear(next.year);
      setMonth(next.month);
    },
    [year, month]
  );

  const goToCurrentMonth = useCallback(() => {
    const now = new Date();
    setYear(now.getFullYear());
    setMonth(now.getMonth() + 1);
  }, []);

  /** `YYYY-MM-DD` または `YYYY-MM-DDTHH:mm` のローカル日時へ表示月を合わせる */
  const goToLocalDateTime = useCallback((localDateTime: string) => {
    const datePart = localDateTime.slice(0, 10);
    const parsed = parseRsLocalDateYmd(datePart);
    if (!parsed) return;
    setYear(parsed.year);
    setMonth(parsed.month);
  }, []);

  const isViewingCurrentMonth =
    year === today.getFullYear() && month === today.getMonth() + 1;

  return {
    today,
    year,
    month,
    shiftMonth,
    goToCurrentMonth,
    goToLocalDateTime,
    isViewingCurrentMonth,
  };
}
